import { initI18n } from '@biofarma/i18n';
import { pwaApi } from '../lib/api.js';
import it from './locales/it.json';
import en from './locales/en.json';
import fr from './locales/fr.json';

const LOCALES = ['it', 'en', 'fr'] as const;

// I testi statici PWA vivono ora nel DB (tabelle pwa_texts/pwa_texts_i18n, editabili da
// Amministrazione → Traduzioni) — vengono scaricati a runtime così le modifiche sono visibili
// senza rideploy. Il bundle statico sotto resta come fallback se la rete non è disponibile
// all'avvio (la PWA non ha ancora sync offline, vedi STATO IMPLEMENTAZIONE in CLAUDE.md).
async function fetchRemoteTexts(): Promise<Partial<Record<(typeof LOCALES)[number], Record<string, string>>>> {
  const result: Partial<Record<(typeof LOCALES)[number], Record<string, string>>> = {};
  await Promise.all(LOCALES.map(async (code) => {
    try {
      const { data } = await pwaApi.get(`/tablet/pwa-texts`, { params: { lang: code } });
      const texts = data?.data as Record<string, string> | undefined;
      if (texts && Object.keys(texts).length > 0) result[code] = texts;
    } catch {
      // offline o errore di rete: nessun aggiornamento per questa lingua, resta il bundle statico
    }
  }));
  return result;
}

export async function setupPwaI18n(initialLocale: 'it' | 'en' | 'fr' = 'it') {
  const bundled = { it, en, fr };
  const remote = await fetchRemoteTexts();

  const resources = {
    it: { ...bundled.it, ...remote.it },
    en: { ...bundled.en, ...remote.en },
    fr: { ...bundled.fr, ...remote.fr },
  };

  return initI18n({
    defaultLocale: initialLocale,
    fallbackLocale: 'it',
    resources,
  });
}
